import { Logger } from "./logger";
export class Beacon {
    static send(url, data) {
        let _jsonData = JSON.stringify(data);
        Logger.verbose("Sending beacon");
        Logger.verbose(url);
        Logger.verbose(_jsonData);
        let status = navigator.sendBeacon(url, _jsonData);
        Logger.verbose("Beacon Status => " + status);
    }
}
